/*
    © 2021 EcomGraduates
*/

// Sort by
document.querySelector('#sort-by')?.addEventListener('change', (e) => {
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set(e.target.getAttribute('name'), e.target.value)
    window.location.search = searchParams.toString()
})

// Init Ajaxinate (infinite scrolling)
const initAjaxinate = () => {
    if (document.querySelector('#AjaxinatePagination')) {
        // eslint-disable-next-line no-unused-vars
        const endlessScroll = new Ajaxinate({
            pagination: '#AjaxinatePagination',
            container: '#AjaxinateContainer',
            method: 'click',
            loadingText: 'Loading...'
        })
    }
}
initAjaxinate()

// Collection filters - handle filtering
const initCollectionFilters = () => {
    const form = document.querySelector('#filter-form')

    if (!form) {
        return false
    }

    document.querySelectorAll('.collection-filter').forEach((filter) => {
        filter.addEventListener('change', (e) => {
            const searchParams = new URLSearchParams(window.location.search)
            const productList = document.querySelector('#main .product-list')
            productList.style.opacity = 0.25

            if (e.target.getAttribute('type') === 'checkbox') {
                if (e.target.checked) {
                    searchParams.append(e.target.getAttribute('name'), e.target.getAttribute('value'))
                } else {
                    const array = []
                    searchParams.forEach((value, key) => {
                        if (value !== e.target.getAttribute('value')) {
                            array.push({ [key]: value })
                        }
                    })
                    searchParams.delete(e.target.getAttribute('name'))
                    array.forEach((item, index) => {
                        const key = Object.keys(item)[0]
                        const value = Object.values(item)[0]
                        searchParams.append(key, value)
                    })
                }
            }
            if (e.target.getAttribute('type') === 'number') {
                if (e.target.value > 0) {
                    searchParams.set(e.target.getAttribute('name'), e.target.value)
                } else {
                    searchParams.delete(e.target.getAttribute('name'))
                }
            }
            const url = `${window.location.pathname}?${searchParams}`
            window.history.replaceState({}, '', url)

            setTimeout(() => {
                const offcanvas = document.querySelector('#offcanvas-filters')
                bootstrap.Offcanvas.getInstance(offcanvas)?.hide()
            }, 200)

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser()
                    const newDocument = parser.parseFromString(data, 'text/html')
                    document.querySelector('#filters-col').replaceWith(newDocument.querySelector('#filters-col'))
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'))
                    initCollectionFilters()
                    initAjaxinate()
                })
        })
    })

    document.querySelectorAll('.active-filter').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault()
            window.history.replaceState({}, '', e.target.getAttribute('href'))

            fetch(window.location.href)
                .then((response) => response.text())
                .then((data) => {
                    const parser = new DOMParser()
                    const newDocument = parser.parseFromString(data, 'text/html')
                    document.querySelector('#filters-col').replaceWith(newDocument.querySelector('#filters-col'))
                    document.querySelector('#main-col').replaceWith(newDocument.querySelector('#main-col'))
                    initCollectionFilters()
                    initAjaxinate()
                })
        })
    })
}
initCollectionFilters()

// Collection filters - Build offcanvas
const collectionFiltersAppendOffcanvas = () => {
    const offcanvas = document.querySelector('#offcanvas-filters')

    offcanvas?.addEventListener('show.bs.offcanvas', () => {
        const filters = document.querySelector('#filter-form')
        offcanvas.querySelector('.offcanvas-body').append(filters)
    })
}
collectionFiltersAppendOffcanvas()
